import log from 'loglevel'
import axios, { type AxiosHeaders } from 'axios'
import { isNil } from 'lodash/fp'

import { url, getCustomHeaders } from 'components/DataProvider/functions'

log.setLevel(log.levels.DEBUG)

export const doExecute = async (id: string): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const headers = getCustomHeaders() as AxiosHeaders | undefined
  if (isNil(headers)) return undefined
  const { status } = await axios.delete(`${url}/cognito/users/${id}`, {
    headers: { Authorization: headers.get('Authorization') }
  })
  return status
}
